import { Icon } from '@chakra-ui/icons'

const Answered = props => (
    <Icon viewBox="0 0 48 48" fill={'none'} {...props}>
        <rect
            x="1.5"
            y="1.5"
            width="45"
            height="45"
            rx="22.5"
            fill="#0077FE"
            stroke="#454545"
            strokeWidth="3"
        />
        <path
            d="M24.3985 28.5C24.3052 28.5 24.2212 28.4673 24.1465 28.402C24.0812 28.3367 24.0485 28.2527 24.0485 28.15V21.486L22.1305 22.956C22.0465 23.0213 21.9578 23.0447 21.8645 23.026C21.7805 23.0073 21.7058 22.956 21.6405 22.872L20.8145 21.794C20.7585 21.71 20.7352 21.6213 20.7445 21.528C20.7632 21.4253 20.8192 21.346 20.9125 21.29L24.1325 18.798C24.1885 18.7607 24.2398 18.7373 24.2865 18.728C24.3425 18.7093 24.4032 18.7 24.4685 18.7H26.2185C26.3118 18.7 26.3912 18.7327 26.4565 18.798C26.5312 18.8633 26.5685 18.9473 26.5685 19.05V28.15C26.5685 28.2527 26.5312 28.3367 26.4565 28.402C26.3912 28.4673 26.3118 28.5 26.2185 28.5H24.3985Z"
            fill="white"
        />
    </Icon>
)

const UnAnswered = props => (
    <Icon viewBox="0 0 48 48" fill={'none'} {...props}>
        <rect
            x="1.5"
            y="1.5"
            width="45"
            height="45"
            fill="white"
            stroke="#454545"
            strokeWidth="3"
        />
        <path
            d="M19.8853 28.5C19.7826 28.5 19.6939 28.4673 19.6193 28.402C19.5539 28.3367 19.5213 28.2527 19.5213 28.15V27.156C19.5213 27.0907 19.5399 26.9927 19.5773 26.862C19.6146 26.722 19.7126 26.5913 19.8713 26.47L21.3273 25.042C22.0739 24.4727 22.6853 23.992 23.1613 23.6C23.6466 23.1987 24.0059 22.844 24.2393 22.536C24.4726 22.228 24.5893 21.9387 24.5893 21.668C24.5893 21.3507 24.5053 21.0893 24.3373 20.884C24.1786 20.6693 23.8986 20.562 23.4973 20.562C23.2266 20.562 22.9979 20.6227 22.8113 20.744C22.6339 20.856 22.4986 21.0053 22.4053 21.192C22.3119 21.3787 22.2466 21.57 22.2093 21.766C22.1719 21.8873 22.1066 21.9713 22.0133 22.018C21.9293 22.0647 21.8359 22.088 21.7333 22.088H19.9833C19.8993 22.088 19.8293 22.06 19.7733 22.004C19.7173 21.948 19.6893 21.878 19.6893 21.794C19.6986 21.346 19.7919 20.926 19.9693 20.534C20.1559 20.142 20.4126 19.7967 20.7393 19.498C21.0753 19.19 21.4719 18.952 21.9293 18.784C22.3959 18.616 22.9186 18.532 23.4973 18.532C24.2906 18.532 24.9626 18.658 25.5133 18.91C26.0733 19.162 26.4979 19.5167 26.7873 19.974C27.0766 20.422 27.2213 20.9493 27.2213 21.556C27.2213 22.0133 27.1186 22.4427 26.9133 22.844C26.7173 23.236 26.4326 23.614 26.0593 23.978C25.6953 24.3327 25.2613 24.7013 24.7573 25.084L23.4693 26.386H27.0673C27.1699 26.386 27.2539 26.4187 27.3193 26.484C27.3939 26.5493 27.4313 26.6333 27.4313 26.736V28.15C27.4313 28.2527 27.3939 28.3367 27.3193 28.402C27.2539 28.4673 27.1699 28.5 27.0673 28.5H19.8853Z"
            fill="#191919"
        />
    </Icon>
)

const CurrentQn = props => (
    <Icon viewBox="0 0 60 60" fill={'none'} {...props}>
        <rect
            x="2"
            y="2"
            width="56"
            height="56"
            stroke="#6E5A8A"
            strokeWidth="3"
        />
        <rect
            x="7.5"
            y="7.5"
            width="45"
            height="45"
            fill="white"
            stroke="#454545"
            strokeWidth="3"
        />
        <path
            d="M25.8458 34.5C25.7524 34.5 25.6684 34.4673 25.5938 34.402C25.5284 34.3367 25.4958 34.2527 25.4958 34.15V27.486L23.5778 28.956C23.4938 29.0213 23.4051 29.0447 23.3118 29.026C23.2278 29.0073 23.1531 28.956 23.0878 28.872L22.2618 27.794C22.2058 27.71 22.1824 27.6213 22.1918 27.528C22.2104 27.4253 22.2664 27.346 22.3598 27.29L25.5798 24.798C25.6358 24.7607 25.6871 24.7373 25.7338 24.728C25.7898 24.7093 25.8504 24.7 25.9158 24.7H27.6658C27.7591 24.7 27.8384 24.7327 27.9038 24.798C27.9784 24.8633 28.0158 24.9473 28.0158 25.05V34.15C28.0158 34.2527 27.9784 34.3367 27.9038 34.402C27.8384 34.4673 27.7591 34.5 27.6658 34.5H25.8458ZM29.8648 34.5C29.7621 34.5 29.6734 34.4673 29.5988 34.402C29.5334 34.3367 29.5008 34.2527 29.5008 34.15V33.156C29.5008 33.0907 29.5194 32.9927 29.5568 32.862C29.5941 32.722 29.6921 32.5913 29.8508 32.47L31.3068 31.042C32.0534 30.4727 32.6648 29.992 33.1408 29.6C33.6261 29.1987 33.9854 28.844 34.2188 28.536C34.4521 28.228 34.5688 27.9387 34.5688 27.668C34.5688 27.3507 34.4848 27.0893 34.3168 26.884C34.1581 26.6693 33.8781 26.562 33.4768 26.562C33.2061 26.562 32.9774 26.6227 32.7908 26.744C32.6134 26.856 32.4781 27.0053 32.3848 27.192C32.2914 27.3787 32.2261 27.57 32.1888 27.766C32.1514 27.8873 32.0861 27.9713 31.9928 28.018C31.9088 28.0647 31.8154 28.088 31.7128 28.088H29.9628C29.8788 28.088 29.8088 28.06 29.7528 28.004C29.6968 27.948 29.6688 27.878 29.6688 27.794C29.6781 27.346 29.7714 26.926 29.9488 26.534C30.1354 26.142 30.3921 25.7967 30.7188 25.498C31.0548 25.19 31.4514 24.952 31.9088 24.784C32.3754 24.616 32.8981 24.532 33.4768 24.532C34.2701 24.532 34.9421 24.658 35.4928 24.91C36.0528 25.162 36.4774 25.5167 36.7668 25.974C37.0561 26.422 37.2008 26.9493 37.2008 27.556C37.2008 28.0133 37.0981 28.4427 36.8928 28.844C36.6968 29.236 36.4121 29.614 36.0388 29.978C35.6748 30.3327 35.2408 30.7013 34.7368 31.084L33.4488 32.386H37.0468C37.1494 32.386 37.2334 32.4187 37.2988 32.484C37.3734 32.5493 37.4108 32.6333 37.4108 32.736V34.15C37.4108 34.2527 37.3734 34.3367 37.2988 34.402C37.2334 34.4673 37.1494 34.5 37.0468 34.5H29.8648Z"
            fill="#191919"
        />
    </Icon>
)

const ReviewAnswered = props => (
    <Icon viewBox="0 0 48 48" fill={'none'} {...props}>
        <path
            d="M10.0504 46.5L1.73615 20.0221L24 1.93271L46.2639 20.0221L37.9496 46.5H10.0504Z"
            fill="#F29100"
            stroke="#454545"
            strokeWidth="3"
        />
        <path
            d="M23.9546 28.654C23.0773 28.654 22.3446 28.5187 21.7566 28.248C21.1686 27.968 20.7206 27.6087 20.4126 27.17C20.1139 26.722 19.9553 26.2413 19.9366 25.728C19.9366 25.644 19.9646 25.574 20.0206 25.518C20.0766 25.462 20.1466 25.434 20.2306 25.434H22.1066C22.2279 25.434 22.3213 25.462 22.3866 25.518C22.4613 25.5647 22.5173 25.6253 22.5546 25.7C22.6386 25.9147 22.7459 26.092 22.8766 26.232C23.0166 26.372 23.1753 26.4747 23.3526 26.54C23.5393 26.6053 23.7446 26.638 23.9686 26.638C24.2299 26.638 24.4726 26.582 24.6966 26.47C24.9206 26.358 25.0979 26.1947 25.2286 25.98C25.3686 25.756 25.4386 25.49 25.4386 25.182C25.4386 24.902 25.3733 24.6593 25.2426 24.454C25.1213 24.2487 24.9486 24.0853 24.7246 23.964C24.5006 23.8427 24.2486 23.782 23.9686 23.782C23.7446 23.782 23.5626 23.81 23.4226 23.866C23.2826 23.9127 23.1659 23.9733 23.0726 24.048C22.9793 24.1227 22.8953 24.188 22.8206 24.244C22.7459 24.2907 22.6619 24.314 22.5686 24.314H20.7346C20.6506 24.314 20.5759 24.286 20.5106 24.23C20.4546 24.1647 20.4266 24.09 20.4266 24.006L20.9306 19.12C20.9493 18.98 21.0006 18.8773 21.0846 18.812C21.1686 18.7373 21.2713 18.7 21.3926 18.7H27.0066C27.1093 18.7 27.1933 18.7327 27.2586 18.798C27.3239 18.8633 27.3566 18.9473 27.3566 19.05V20.366C27.3566 20.4687 27.3239 20.5527 27.2586 20.618C27.1933 20.6833 27.1093 20.716 27.0066 20.716H22.9466L22.7646 22.536C22.9699 22.396 23.2079 22.284 23.4786 22.2C23.7586 22.1067 24.1366 22.06 24.6126 22.06C25.0606 22.06 25.4853 22.1347 25.8866 22.284C26.2973 22.4333 26.6613 22.648 26.9786 22.928C27.3053 23.208 27.5573 23.544 27.7346 23.936C27.9213 24.3187 28.0146 24.7527 28.0146 25.238C28.0146 25.9007 27.8513 26.4887 27.5246 27.002C27.2073 27.5153 26.7453 27.9213 26.1386 28.22C25.5319 28.5093 24.8039 28.654 23.9546 28.654Z"
            fill="white"
        />
        <circle cx="40" cy="40" r="8" fill="#0077FE" />
    </Icon>
)

const ReviewUnAnswered = props => (
    <Icon viewBox="0 0 48 48" fill={'none'} {...props}>
        <path
            d="M10.0504 46.5L1.73615 20.0221L24 1.93271L46.2639 20.0221L37.9496 46.5H10.0504Z"
            fill="#F29100"
            stroke="#454545"
            strokeWidth="3"
        />
        <path
            d="M19.7843 28.5C19.6909 28.5 19.6069 28.4673 19.5323 28.402C19.4669 28.3367 19.4343 28.2527 19.4343 28.15V21.486L17.5163 22.956C17.4323 23.0213 17.3436 23.0447 17.2503 23.026C17.1663 23.0073 17.0916 22.956 17.0263 22.872L16.2003 21.794C16.1443 21.71 16.1209 21.6213 16.1303 21.528C16.1489 21.4253 16.2049 21.346 16.2983 21.29L19.5183 18.798C19.5743 18.7607 19.6256 18.7373 19.6723 18.728C19.7283 18.7093 19.7889 18.7 19.8543 18.7H21.6043C21.6976 18.7 21.7769 18.7327 21.8423 18.798C21.9169 18.8633 21.9543 18.9473 21.9543 19.05V28.15C21.9543 28.2527 21.9169 28.3367 21.8423 28.402C21.7769 28.4673 21.6976 28.5 21.6043 28.5H19.7843ZM27.4152 28.64C26.6872 28.64 26.0666 28.556 25.5532 28.388C25.0399 28.2107 24.6199 27.9867 24.2932 27.716C23.9666 27.436 23.7239 27.142 23.5652 26.834C23.4066 26.5167 23.3226 26.2133 23.3132 25.924C23.3132 25.84 23.3412 25.77 23.3972 25.714C23.4626 25.658 23.5372 25.63 23.6212 25.63H25.4412C25.5532 25.63 25.6419 25.6533 25.7072 25.7C25.7726 25.7373 25.8332 25.8027 25.8892 25.896C25.9639 26.0733 26.0712 26.218 26.2112 26.33C26.3606 26.442 26.5379 26.5213 26.7432 26.568C26.9486 26.6053 27.1726 26.624 27.4152 26.624C27.8912 26.624 28.2599 26.5167 28.5212 26.302C28.7919 26.078 28.9272 25.7747 28.9272 25.392C28.9272 24.9907 28.8012 24.706 28.5492 24.538C28.2972 24.3607 27.9379 24.272 27.4712 24.272H25.9172C25.8146 24.272 25.7306 24.2393 25.6652 24.174C25.5999 24.1087 25.5672 24.0247 25.5672 23.922V23.138C25.5672 23.026 25.5906 22.928 25.6372 22.844C25.6839 22.76 25.7352 22.6993 25.7912 22.662L28.0872 20.716H24.1952C24.1019 20.716 24.0179 20.6833 23.9432 20.618C23.8779 20.5527 23.8452 20.4687 23.8452 20.366V19.05C23.8452 18.9473 23.8779 18.8633 23.9432 18.798C24.0179 18.7327 24.1019 18.7 24.1952 18.7H30.6352C30.7379 18.7 30.8219 18.7327 30.8872 18.798C30.9619 18.8633 30.9992 18.9473 30.9992 19.05V20.24C30.9992 20.3427 30.9759 20.436 30.9292 20.52C30.8826 20.5947 30.8312 20.6553 30.7752 20.702L28.6472 22.676L28.7452 22.704C29.2772 22.7693 29.7532 22.914 30.1732 23.138C30.5932 23.3527 30.9246 23.656 31.1672 24.048C31.4099 24.44 31.5312 24.9393 31.5312 25.546C31.5312 26.1807 31.3492 26.7313 30.9852 27.198C30.6306 27.6553 30.1452 28.01 29.5292 28.262C28.9132 28.514 28.2086 28.64 27.4152 28.64Z"
            fill="white"
        />
    </Icon>
)

const Idea = props => (
    <Icon viewBox="0 0 32 32" fill={'none'} {...props}>
        <path
            d="M13 29H19M16 4.45582V3M23.5 7.36745L25 5.91164M8.5 7.36745L7 5.91164M24.3437 20.8565L25.8437 22.3123M7.63277 20.8565L6.13277 22.3123M5.5 13.1907H4M28 13.1907H26.5M16 8.09536C17.523 8.09446 19.0015 8.59344 20.1953 9.51121C21.3891 10.429 22.2281 11.7116 22.5758 13.1507C22.9236 14.5897 22.7597 16.1007 22.1108 17.4379C21.4619 18.7751 20.3661 19.86 19.0015 20.5164L19 21.9256C19 22.6978 19.0015 24.8373 19.0015 24.8373C19.0015 24.8373 16.7956 24.8373 16 24.8373C15.2044 24.8373 13 24.8373 13 24.8373C13 24.8373 13 22.6978 13 21.9256V20.5164C11.6355 19.8601 10.5398 18.7753 9.8909 17.4382C9.24197 16.1011 9.07796 14.5904 9.42551 13.1514C9.77306 11.7124 10.6117 10.4298 11.8053 9.51189C12.9989 8.594 14.4772 8.09479 16 8.09536Z"
            stroke="#5C5C5C"
            strokeWidth="3"
            strokeLinecap="square"
        />
    </Icon>
)

const HeartBreak = props => (
    <Icon viewBox="0 0 32 32" fill={'none'} {...props}>
        <path
            d="M6.37418 15.7246C1.73597 11.0857 9.85507 3.54439 15.6507 9.34516C24.9285 2.96197 30.1498 11.0837 24.9288 16.3034L15.651 25.0024L6.37418 15.7246Z"
            fill="white"
            stroke="#5C5C5C"
            strokeWidth="3"
        />
        <path
            d="M16.2327 9.34375L14.4932 12.8229L17.3925 15.1424L14.4932 18.0417L16.2327 20.3611L15.6529 23.8403"
            stroke="#5C5C5C"
        />
    </Icon>
)

const NoCopy = props => (
    <Icon viewBox="0 0 32 32" fill={'none'} {...props}>
        <path
            d="M23.5121 9.40105C21.847 7.5053 19.4677 6.23434 16.753 6.02897C11.2453 5.6123 6.44268 9.73953 6.02604 15.2474C5.81638 18.019 6.75729 20.6121 8.44571 22.5576M23.5121 9.40105C25.2252 11.3515 26.1824 13.9632 25.9711 16.7563C25.5545 22.2642 20.7518 26.3914 15.2442 25.9747C12.508 25.7677 10.1126 24.4782 8.44571 22.5576M23.5121 9.40105L8.44571 22.5576"
            stroke="#5C5C5C"
            strokeWidth="3"
        />
    </Icon>
)

const CheckBoxUnChecked = props => (
    <Icon viewBox="0 0 32 32" fill={'none'} {...props}>
        <rect
            x="5.5"
            y="5.5"
            width="21"
            height="21"
            fill="white"
            stroke="#333333"
            strokeWidth="3"
        />
    </Icon>
)

const CheckBoxChecked = props => (
    <Icon viewBox="0 0 32 32" fill={'none'} {...props}>
        <rect x="4" y="4" width="24" height="24" fill="#0077FE" />
        <path d="M10 15.8121L14.1234 20L22 12" stroke="white" strokeWidth="3" />
    </Icon>
)

export {
    Answered,
    CheckBoxChecked,
    CheckBoxUnChecked,
    CurrentQn,
    HeartBreak,
    Idea,
    NoCopy,
    ReviewAnswered,
    ReviewUnAnswered,
    UnAnswered,
}
